























































































































































































































































import PrivateImage from "@/components/PrivateImage.vue";
import { CheckIsMUZE } from "@/helper/shareHelper";
import { CheckIsDevelop } from "@/helper/shareHelper";
import { MerchantId } from "@/helper/userHelper";
import {
  AuthorityRole,
  LoadingStatusType,
  Locales,
  Package,
  TypeComponentNoti,
} from "@/enums/enums";
import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import InputSearchCompany from "@/views/selectCompany/InputSearchCompany.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const IsMUZE = CheckIsMUZE();

const StoreLogIn = namespace("LogIn");
const StoreAlert = namespace("Alert");

@Component({ components: { InputSearchCompany, PrivateImage } })
export default class SelectCompany extends Vue {
  public inputSearch = "";
  public showDropdown = false;
  public count = 0;
  public classBox = "";
  public classText = "";
  public displayText = "none";
  public displayBox = "none";
  private listDisplay: any = [];
  private listFilter: any = [];
  private isMUZE = IsMUZE;
  private isDevelop = CheckIsDevelop();
  private listMerchant: Array<MerchantInFoModel> = [];
  private listFilterMerchant: Array<MerchantInFoModel> = [];
  private listFavoriteMerchant: Array<MerchantInFoModel> = [];
  private listFilterFavoriteMerchant: Array<MerchantInFoModel> = [];
  private listFilterFavoriteMerchantForMap = new Map();
  public select: any = null;
  public packageType = Package;
  public countDownTime: any = "0";
  public isCurrentMerchant = true;
  private isTimeoutInputSearch = 0;
  private isTimeoutHandleScroll = 0;

  @StoreLogIn.Getter
  private getMerchant!: SelectedMerchantModel;
  @StoreLogIn.Getter
  private getMerchantList!: Array<MerchantInFoModel>;
  @StoreLogIn.Getter
  private getMerchantListLoadingStatus!: LoadingStatusType;
  @StoreLogIn.Getter
  private getFavoriteMerchantList!: any;
  @StoreLogIn.Getter
  private getFavoriteMerchantListLoadingStatus!: LoadingStatusType;
  @StoreLogIn.Getter
  private getMerchantModelListForMap!: Map<number, SelectedMerchantModel>;

  @StoreAlert.Action
  private SetAlertMessage!: (input: any) => void;
  @StoreLogIn.Action
  private DoGetMerchantList!: () => void;
  @StoreLogIn.Action
  private DoGetFavoriteMerchant!: () => void;
  @StoreLogIn.Action
  private DoGetMerchantModelById!: (
    merchantId: number
  ) => Promise<SelectedMerchantModel>;
  @StoreLogIn.Action
  private DoDeleteFavoriteMerchant!: (merchantId: number) => void;
  @StoreLogIn.Action
  private DoUpdateFavoriteMerchant!: (merchantId: number) => void;

  created() {
    this.select = this.getMerchant;
    this.DoCheckAndCountDown();
  }

  mounted() {
    const listBox: any = this.$refs.listBox;
    listBox.addEventListener("scroll", this.HandleScroll);
  }

  @Watch("showDropdown")
  showDropdownChanged() {
    if (this.showDropdown) {
      this.classBox = "boxIn";
      this.classText = "textIn";
      this.displayBox = "";
      this.displayText = "";
    } else {
      this.classText = "textOut";
      setTimeout(() => {
        this.classBox = "boxOut";
        setTimeout(() => {
          this.displayText = "none";
          this.displayBox = "none";
        }, 240);
      }, 240);
    }
  }

  @Watch("inputSearch")
  inputSearchChanged() {
    clearTimeout(this.isTimeoutInputSearch);
    this.isTimeoutInputSearch = setTimeout(() => {
      const listBox: any = this.$refs.listBox;
      listBox.scroll({
        top: 0,
        behavior: "smooth",
      });
      this.SetListFilter();
      this.ResetDatalistDisplay();
    }, 250);
  }

  @Watch("getMerchantListLoadingStatus", { immediate: true })
  getMerchantListLoadingStatusChange(newValue: LoadingStatusType) {
    if (newValue === LoadingStatusType.Success) {
      this.listMerchant = this.getMerchantList;
      this.SetListFilter();
      this.ResetDatalistDisplay();
    } else if (newValue === LoadingStatusType.None) {
      this.DoGetMerchantList();
    }
  }

  @Watch("getFavoriteMerchantListLoadingStatus", { immediate: true })
  getFavoriteMerchantListLoadingStatusChange(newValue: LoadingStatusType) {
    if (this.showDropdown) {
      if (newValue === LoadingStatusType.None) {
        this.DoGetFavoriteMerchant();
      } else if (newValue === LoadingStatusType.Success) {
        this.SetFavoriteMerchantModel();
      }
    }
  }

  public DoCheckAndCountDown() {
    if (
      this.GetExpireDateModel(
        this.select.createDateTime,
        this.select.expireDateTime,
        this.select.isSample,
        this.select.package
      ).isCountDownTime
    ) {
      this.CountDownTimer();
    }
  }

  public CountDownTimer() {
    this.countDownTime = this.CalculateTimeForCountDownExpirePackage();
    setTimeout(() => {
      this.CountDownTimer();
    }, 60000);
  }

  public CalculateTimeForCountDownExpirePackage() {
    const toDate = new Date();
    const tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0);
    let diffMS = tomorrow.getTime() / 1000 - toDate.getTime() / 1000;
    const diffHr = Math.floor(diffMS / 3600);
    diffMS = diffMS - diffHr * 3600;
    const diffMi = Math.floor(diffMS / 60);
    diffMS = diffMS - diffMi * 60;
    const hours = diffHr < 10 ? "0" + diffHr : diffHr;
    return hours + ":" + (diffMi < 10 ? "0" + diffMi : diffMi);
  }

  public ShowDropdown() {
    this.showDropdown = true;
    this.count = 0;

    if (this.getMerchantListLoadingStatus === LoadingStatusType.None) {
      this.DoGetMerchantList();
    } else {
      this.listMerchant = this.getMerchantList;
    }

    if (this.getFavoriteMerchantListLoadingStatus === LoadingStatusType.None) {
      this.DoGetFavoriteMerchant();
    } else {
      this.SetFavoriteMerchantModel();
    }

    if (
      this.getMerchantListLoadingStatus === LoadingStatusType.Success &&
      this.getFavoriteMerchantListLoadingStatus === LoadingStatusType.Success
    ) {
      this.SetListFilter();
      this.ResetDatalistDisplay();
    }
  }

  public SetListFilter() {
    const text = this.inputSearch.toLowerCase();
    if (text) {
      this.listFilterMerchant = this.listMerchant.filter((item) => {
        if (item.merchantName) {
          return item.merchantName.toLowerCase().includes(text.toLowerCase());
        }
        return false;
      });

      this.listFilterFavoriteMerchant = this.listFavoriteMerchant.filter(
        (item) => {
          if (item.merchantName) {
            return item.merchantName.toLowerCase().includes(text.toLowerCase());
          }
          return false;
        }
      );
    } else {
      this.listFilterMerchant = this.listMerchant;
      this.listFilterFavoriteMerchant = this.listFavoriteMerchant;
    }
  }

  public DoSelectMerchant(merchantId: number) {
    window.location.href = `${
      window.location.origin
    }/home?emi=${merchantId.PeakEncryption()}`;
  }

  public RedirectToBillingSetting(merchantId: number) {
    this.isMUZE
      ? ""
      : window.open(
          `${
            process.env.VUE_APP_PeakAccount
          }setting/billing?emi=${merchantId.PeakEncryption()}&tdti=0`
        );
  }

  public GetExpireDateModel(
    createDateTime: any,
    expireDateTime: any,
    merchantIsSample: any,
    currentMainPackageId: any
  ) {
    let expireDate = new Date(expireDateTime);
    let dateTime = new Date();
    expireDate = new Date(
      expireDate.getFullYear(),
      expireDate.getMonth(),
      expireDate.getDate()
    );
    dateTime = new Date(
      dateTime.getFullYear(),
      dateTime.getMonth(),
      dateTime.getDate()
    );
    if (currentMainPackageId == Package.Trial) {
      const createDate = new Date(createDateTime);
      expireDate = new Date(
        createDate.getFullYear(),
        createDate.getMonth(),
        createDate.getDate()
      );
      expireDate.setDate(expireDate.getDate() + 30);
    }
    /* eslint-disable @typescript-eslint/camelcase */
    const Difference_In_Time = expireDate.getTime() - dateTime.getTime();
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    const result: any = {
      title: "",
      expireDate: false,
      isCountDownTime: false,
    };

    if (merchantIsSample) {
      result.title = this.$t(
        "Create_Entity_Objective_list.For_Try_Out_Features"
      );
    } else if (Difference_In_Days > 0) {
      result.title = this.$t("Remaining_X_days", {
        msg: Difference_In_Days.FormatMoney(0),
      });
    } else if (Difference_In_Days == 0) {
      result.title = this.$t("RemainingHours", { times: this.countDownTime });
      result.isCountDownTime = true;
    } else {
      result.title = this.$t("Click_This_To_Upgrade");
      result.expireDate = true;
    }

    return result;
  }

  public hide() {
    if (this.showDropdown) {
      this.count += 1;
      if (this.count == 2) {
        this.showDropdown = false;
        this.count = 0;
      }
    } else {
      this.count = 0;
    }
  }

  public GetMerchantName(merchant: any) {
    let merchantFullName = "";
    if (this.$i18n.locale == Locales.TH) {
      merchantFullName = merchant.merchantNameTh;
    } else {
      merchantFullName = merchant.merchantNameEng;
    }
    if (merchant.merchantBranchCode != "") {
      if (merchant.merchantBranchCode == "00000") {
        merchantFullName += " " + "(" + this.$t("head_quarter") + ")";
      } else {
        merchantFullName += " " + "(" + merchant.merchantBranchCode + ")";
      }
    }
    return merchantFullName;
  }

  public HandleScroll() {
    const listBox: any = this.$refs.listBox;
    const scrollHeight = listBox.scrollHeight;
    const scrollTop = listBox.scrollTop;
    const clientHeight = listBox.clientHeight;
    const scroll = scrollHeight - (scrollTop + clientHeight);
    if (scroll < 300) {
      if (this.listDisplay.length < this.listFilterMerchant.length) {
        this.listDisplay.push({
          merchantId: this.listFilterMerchant[this.listDisplay.length]
            .merchantId,
        });
      }
    }

    clearTimeout(this.isTimeoutHandleScroll);
    this.isTimeoutHandleScroll = setTimeout(() => {
      const merchantIdList = [];
      for (const merchant of this.listDisplay) {
        if (!merchant.merchantName && merchant.merchantId > 0) {
          merchantIdList.push(merchant.merchantId);
        }
      }
      if (merchantIdList.length > 0) {
        this.GetMerchantModel(merchantIdList);
      }
    }, 250);
  }

  public ResetDatalistDisplay() {
    this.listDisplay = [];
    const merchantIdList = [];
    for (let i = 0; i < 10; i++) {
      if (i < this.listFilterMerchant.length) {
        this.listDisplay.push({
          merchantId: this.listFilterMerchant[i].merchantId,
        });
        merchantIdList.push(this.listFilterMerchant[i].merchantId);
      }
    }

    if (merchantIdList.length > 0) {
      this.GetMerchantModel(merchantIdList);
    }

    setTimeout(() => {
      this.SetFavoriteMerchantForMerchantList();
    }, 0);
  }

  public GetAuthorityRole(authorityRole: AuthorityRole, isSuperUser: boolean) {
    let role: any = "";
    if (isSuperUser) {
      role = this.$t("Super_Admin_Role");
    } else {
      switch (authorityRole) {
        case AuthorityRole.ViewOnly:
          role = this.$t("View_Only_Role");
          break;
        case AuthorityRole.PartialRights:
          role = this.$t("Partial_Role");
          break;
        case AuthorityRole.StandardRights:
          role = this.$t("Basic_Role");
          break;
        case AuthorityRole.Admin:
          role = this.$t("Admin_Role");
          break;
      }
    }

    return role;
  }

  public UpdateMerchantFavoriteByMerchantId(merchantId: number) {
    if (
      this.getFavoriteMerchantListLoadingStatus != LoadingStatusType.Loading
    ) {
      if (this.getFavoriteMerchantList.length > 0) {
        const isHaveMerchantId = this.getFavoriteMerchantList.find(
          (item: any) => item.merchantId === merchantId
        );
        if (isHaveMerchantId) {
          this.DoDeleteFavoriteMerchant(merchantId);
        } else {
          this.DoUpdateFavoriteMerchant(merchantId);
        }
      } else {
        this.DoUpdateFavoriteMerchant(merchantId);
      }
    }
  }

  public CopyMerchantCode(merchantCode: string) {
    navigator.clipboard.writeText(merchantCode);
    this.SetAlertMessage({
      alertMessage: this.$t("Merchant_Code_Copied_Alert"),
      typeMessage: TypeComponentNoti.Success,
    });
  }

  public async GetMerchantModel(merchantIdList: any) {
    for (const merchantId of merchantIdList) {
      const merchantModel = await this.DoGetMerchantModelById(merchantId);
      if (merchantModel) {
        const indexMerchant = this.listDisplay.findIndex(
          (x: any) => x.merchantId == merchantId && !x.isFavorite
        );
        if (indexMerchant > -1) {
          this.listDisplay.splice(indexMerchant, 1, {
            ...merchantModel,
            isFavorite: false,
          });
        }
      }
    }
  }

  public async SetFavoriteMerchantModel() {
    if (
      this.getFavoriteMerchantListLoadingStatus == LoadingStatusType.Success
    ) {
      this.listFavoriteMerchant = [];
      this.listFilterFavoriteMerchant = [];
      for (const favoriteMerchant of this.getFavoriteMerchantList) {
        const merchantModel = await this.DoGetMerchantModelById(
          favoriteMerchant.merchantId
        );
        if (merchantModel) {
          this.listFavoriteMerchant.push(merchantModel);
        }
      }

      this.SetListFilter();
      this.ResetDatalistDisplay();
    }
  }

  public SetFavoriteMerchantForMerchantList() {
    this.listFilterFavoriteMerchantForMap = new Map();
    for (const filterFavoriteMerchant of this.listFilterFavoriteMerchant) {
      this.listDisplay.unshift({ ...filterFavoriteMerchant, isFavorite: true });
      this.listFilterFavoriteMerchantForMap.set(
        filterFavoriteMerchant.merchantId,
        filterFavoriteMerchant.merchantId
      );
    }
  }

  public CheckCanShowItem(merchant: any) {
    if (merchant.isFavorite) {
      return true;
    }

    if (!this.listFilterFavoriteMerchantForMap.get(merchant.merchantId)) {
      return true;
    }

    return false;
  }

  public ToggleFocus() {
    const children: any = this.$children[0];
    children.ToggleFocus();
  }

  public OpenInputSearch() {
    this.ToggleFocus();
  }
}
